// extracted by mini-css-extract-plugin
export var slideGridViewLink = "CardsContainerSlide-module--slideGridViewLink--f771f";
export var sliderContainer = "CardsContainerSlide-module--sliderContainer--ed7ef";
export var swiperWrapper = "CardsContainerSlide-module--swiper-wrapper--c9605";